<div class="content">
    <app-articles-display 
        *appHasFeature="features.TAB_GOAL_GUIDES"
        [title]="'Homepage-GoalGuides'" 
        region="GOALGUIDES">
    </app-articles-display>
    
    <app-homepage-employee-goals-widget [employeeId]="user$.userId"></app-homepage-employee-goals-widget>
    
    <app-my-reviews [employeeId]="user$.userId"></app-my-reviews>
</div>